/* =========================================================
   FIX 198 — mixér nálepiek pod tlačidlom „Pridať do košíka“.

   Do košíka ide JEDEN riadok: zvolený variant balíka (napr. „4 ks“)
   a k nemu vlastnosť „Výber nálepiek“ s textom „Škoda ×2 | BMW ×1“.

   V299 — prepísané na delegované udalosti.
   Predtým sa posluchači viazali na konkrétne tlačidlá pri načítaní stránky.
   Bočný košík sa ale po každej zmene prekreslí (morph) a <script> vložený do
   prekresleného HTML sa nespustí — nový prúžok nálepiek tak nemal žiadne
   posluchače a ťuknutie „nerobilo nič“. Teraz počúva jeden posluchač na
   dokumente a stav každého mixéra je uložený pri jeho koreňovom prvku,
   takže funguje aj na prvkoch, ktoré vzniknú až neskôr.
   ========================================================= */
(function () {
  'use strict';
  if (window.__aoStickerBundleV299) return;
  window.__aoStickerBundleV299 = true;

  var ROOT_SEL = '[data-ao-sticker-bundle]';
  var states = new WeakMap();

  function shopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }
  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function state(root) {
    var s = states.get(root);
    if (s) return s;
    s = {
      target: 0,
      variantId: 0,
      priceText: '',
      originalPriceCents: 0,
      isSingle: false,
      lang: root.dataset.sbDefaultLang === 'cz' ? 'cz' : 'sk',
      busy: false,
      panelTimer: 0,
      counts: new Map(),
      expanded: root.dataset.sbExpanded === 'true'
    };
    states.set(root, s);
    return s;
  }

  function cardsOf(root) { return qa(root, '[data-sb-card]'); }
  function packsOf(root) { return qa(root, '[data-sb-pack]'); }
  function singlePackOf(root) { return q(root, '[data-sb-pack][data-sb-single="true"]'); }

  function chosenTotal(s) {
    var sum = 0;
    s.counts.forEach(function (n) { sum += n; });
    return sum;
  }
  function selectedTotal(s) { return s.isSingle ? s.target : chosenTotal(s); }

  function singleVariantId(root, s) {
    var single = singlePackOf(root);
    if (!single) return 0;
    var raw = s.lang === 'cz' ? single.dataset.variantCz : single.dataset.variantSk;
    return Number(raw) || Number(single.dataset.variantId) || 0;
  }

  function showMessage(root, text, kind) {
    var message = q(root, '[data-sb-msg]');
    if (!message) return;
    message.hidden = !text;
    message.textContent = text || '';
    message.classList.toggle('is-error', kind === 'error');
    message.classList.toggle('is-success', kind === 'success');
  }

  /* Štýlová lišta patrí len stránke nálepky (FIX 213). */
  function sticky() {
    var own = document.querySelector('[data-sticky-cart][data-sticky-mode="bundle"]');
    return own ? {
      pack: own.querySelector('[data-sticky-pack]'),
      lang: own.querySelector('[data-sticky-lang]'),
      price: own.querySelector('[data-sticky-price]'),
      add: own.querySelector('[data-sticky-add]')
    } : null;
  }

  function renderSlots(root, s, total) {
    var slots = q(root, '[data-sb-slots]');
    if (!slots) return;
    if (slots.childElementCount !== s.target) {
      slots.textContent = '';
      for (var i = 0; i < s.target; i++) slots.appendChild(document.createElement('i'));
    }
    Array.prototype.forEach.call(slots.children, function (dot, i) { dot.classList.toggle('is-on', i < total); });
  }

  function render(root) {
    var s = state(root);
    var total = selectedTotal(s);
    var full = s.target > 0 && total === s.target;
    renderSlots(root, s, s.isSingle ? 0 : total);

    cardsOf(root).forEach(function (card) {
      var name = card.dataset.stickerName;
      var n = s.counts.get(name) || 0;
      var out = card.querySelector('[data-sb-qty]');
      var badge = card.querySelector('[data-sb-badge]');
      var minus = card.querySelector('[data-sb-minus]');
      var plus = card.querySelector('[data-sb-plus]');
      if (out) out.textContent = String(n);
      if (badge) { badge.hidden = n === 0; badge.textContent = String(n); }
      if (minus) minus.disabled = s.busy || n === 0;
      if (plus) plus.disabled = s.busy || s.isSingle || s.target === 0 || chosenTotal(s) >= s.target;
      card.classList.toggle('is-chosen', n > 0);
    });

    var counter = q(root, '[data-sb-counter]');
    if (counter) {
      if (s.target === 0 || s.isSingle) counter.textContent = '';
      else if (full) counter.textContent = 'Balík je plný: ' + total + ' z ' + s.target + ' ks.';
      else counter.textContent = 'Vybrané ' + total + ' z ' + s.target + ' ks — zostáva ' + (s.target - total) + '.';
      counter.classList.toggle('is-full', full);
    }

    var addButton = q(root, '[data-sb-add]');
    var addLabel = q(root, '[data-sb-add-label]');
    var addPrice = q(root, '[data-sb-add-price]');
    if (addButton) {
      addButton.disabled = s.busy || !full;
      addButton.classList.toggle('is-busy', s.busy);
    }
    if (addLabel) {
      if (s.busy) addLabel.textContent = 'Pridávam…';
      else if (s.target === 0) addLabel.textContent = 'Vyber balík';
      else if (!full) addLabel.textContent = 'Vyber ešte ' + (s.target - total) + ' ks';
      else if (s.expanded) addLabel.textContent = 'Pridať do košíka';
      else addLabel.textContent = 'Pridať nálepky zvlášť do košíka';
    }
    if (addPrice) {
      addPrice.hidden = !(full && s.priceText && !s.busy);
      addPrice.textContent = s.priceText;
    }

    if (s.expanded) {
      var st = sticky();
      if (st) {
        if (st.pack) st.pack.textContent = s.target > 0 ? s.target + ' ks' : 'Vyber balík';
        if (st.lang) st.lang.textContent = s.lang === 'cz' ? '🇨🇿 Česká' : '🇸🇰 Slovenská';
        if (st.price && s.priceText) st.price.textContent = s.priceText;
        if (st.add) {
          st.add.disabled = s.busy || !full;
          st.add.textContent = s.busy
            ? 'Pridávam…'
            : (s.target === 0 ? 'Vyber balík' : (full ? 'Pridať do košíka' : 'Vyber ešte ' + (s.target - total) + ' ks'));
        }
      }
    }
  }

  function applyLanguage(root) {
    var s = state(root);
    cardsOf(root).forEach(function (card) {
      var img = card.querySelector('img[data-sb-img-sk]');
      if (!img) return;
      var next = s.lang === 'cz' ? img.dataset.sbImgCz : img.dataset.sbImgSk;
      if (next && img.getAttribute('src') !== next) img.setAttribute('src', next);
    });
    if (s.isSingle) s.variantId = singleVariantId(root, s);
    if (!s.expanded) {
      document.dispatchEvent(new CustomEvent('ao:sticker-lang', { detail: { lang: s.lang } }));
    }
    render(root);
  }

  /* Rozbalenie cez mriežku 0fr → 1fr (FIX 213). */
  function setPanel(root, open) {
    var s = state(root);
    var toggle = q(root, '[data-sb-toggle]');
    var panel = q(root, '[data-sb-panel]');
    if (!toggle || !panel) return;
    window.clearTimeout(s.panelTimer);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (open) {
      panel.hidden = false;
      if (reduceMotion) { root.classList.add('is-open'); return; }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (toggle.getAttribute('aria-expanded') === 'true') root.classList.add('is-open');
        });
      });
      try { if (typeof window.clarity === 'function') window.clarity('event', 'cart_stickers_open'); } catch (e) {}
    } else {
      root.classList.remove('is-open');
      s.panelTimer = window.setTimeout(function () {
        if (toggle.getAttribute('aria-expanded') === 'false') panel.hidden = true;
      }, reduceMotion ? 0 : 360);
    }
  }

  function choosePack(root, pack, animate) {
    var s = state(root);
    var next = Number(pack.dataset.count) || 0;
    packsOf(root).forEach(function (p) {
      var on = p === pack;
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
      p.classList.toggle('is-selected', on);
    });
    var first = s.target === 0;
    s.target = next;
    s.isSingle = pack.dataset.sbSingle === 'true';
    s.variantId = s.isSingle ? singleVariantId(root, s) : (Number(pack.dataset.variantId) || 0);
    s.priceText = pack.dataset.priceText || '';
    s.originalPriceCents = Number(pack.dataset.originalPriceCents) || 0;
    if (chosenTotal(s) > s.target) s.counts.forEach(function (_, key) { s.counts.set(key, 0); });
    showMessage(root, '', '');
    var mix = q(root, '[data-sb-mix]');
    if (mix) {
      mix.hidden = s.isSingle;
      if (!s.isSingle && first && animate) {
        mix.classList.add('is-revealing');
        window.setTimeout(function () { mix.classList.remove('is-revealing'); }, 320);
      }
    }
    render(root);
  }

  /* Po prekreslení košíka sa obnoví vybraný balík aj počty z uloženého stavu. */
  function syncFromState(root) {
    var s = state(root);
    if (s.target > 0) {
      var pack = packsOf(root).filter(function (p) {
        return (Number(p.dataset.count) || 0) === s.target && (p.dataset.sbSingle === 'true') === s.isSingle;
      })[0];
      if (pack) {
        packsOf(root).forEach(function (p) {
          var on = p === pack;
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
          p.classList.toggle('is-selected', on);
        });
        var mix = q(root, '[data-sb-mix]');
        if (mix) mix.hidden = s.isSingle;
      }
    }
    render(root);
  }

  function addToCart(root) {
    var s = state(root);
    if (s.busy || !s.variantId || selectedTotal(s) !== s.target || s.target === 0) return;

    var parts = [];
    cardsOf(root).forEach(function (card) {
      var n = s.counts.get(card.dataset.stickerName) || 0;
      if (n > 0) parts.push(card.dataset.stickerName + ' ×' + n);
    });

    s.busy = true;
    showMessage(root, '', '');
    render(root);

    var variantId = s.variantId;
    var target = s.target;
    var body = s.isSingle
      ? { items: [{ id: variantId, quantity: 1 }] }
      : {
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              'Balík nálepiek': target + ' ks',
              'Jazyk nálepiek': s.lang === 'cz' ? 'Česká verzia' : 'Slovenská verzia',
              'Výber nálepiek': parts.join(' | '),
              '_AO pôvodná cena': String(s.originalPriceCents)
            }
          }]
        };

    var sectionIds = qa(document, 'cart-items-component[data-section-id]')
      .map(function (item) { return item.dataset.sectionId; })
      .filter(function (id, index, all) { return id && all.indexOf(id) === index; });
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) return response.json().catch(function () { return {}; }).then(function (data) {
        throw new Error(data.description || data.message || 'add-failed');
      });
      return response.json();
    }).then(function (added) {
      return fetch(shopRoot() + 'cart.js', {
        credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store'
      }).then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (cart) { return { added: added, cart: cart }; });
    }).then(function (result) {
      s.counts.forEach(function (_, key) { s.counts.set(key, 0); });
      showMessage(root, 'Nálepky sú v košíku 🏁', 'success');
      var cart = result.cart;
      var added = result.added || {};
      if (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart, cart: cart,
            data: {
              source: 'ao-sticker-bundle',
              itemCount: Number(cart.item_count) || 0,
              variantId: String(variantId),
              productTitle: 'Nálepky pridané do košíka',
              sections: added.sections || {}
            }
          }
        }));
      }
      window.AOAnalytics && window.AOAnalytics.track && window.AOAnalytics.track('sticker_bundle_added', { pack: target });
    }).catch(function (error) {
      showMessage(root, 'Balík sa nepodarilo pridať. Skús to, prosím, znova.', 'error');
      window.AOAnalytics && window.AOAnalytics.track && window.AOAnalytics.track('sticker_bundle_failed', {
        reason: String((error && error.message) || 'unknown')
      });
    }).then(function () {
      s.busy = false;
      document.querySelectorAll(ROOT_SEL).forEach(function (r) { if (states.get(r) === s) render(r); });
    });
  }

  /* ---------- jeden posluchač pre všetky mixéry ---------- */
  document.addEventListener('click', function (event) {
    var t = event.target instanceof Element ? event.target : null;
    if (!t) return;

    /* Lišta na stránke nálepky nie je vnútri mixéra. */
    var stickyAdd = t.closest('[data-sticky-cart][data-sticky-mode="bundle"] [data-sticky-add]');
    if (stickyAdd) {
      var expandedRoot = document.querySelector(ROOT_SEL + '[data-sb-expanded="true"]');
      if (expandedRoot) addToCart(expandedRoot);
      return;
    }

    var root = t.closest(ROOT_SEL);
    if (!root) return;
    var s = state(root);

    var toggle = t.closest('[data-sb-toggle]');
    if (toggle) {
      event.preventDefault();
      setPanel(root, toggle.getAttribute('aria-expanded') !== 'true');
      return;
    }

    var langBtn = t.closest('[data-sb-lang]');
    if (langBtn) {
      if (s.busy) return;
      s.lang = langBtn.dataset.sbLang === 'cz' ? 'cz' : 'sk';
      qa(root, '[data-sb-lang]').forEach(function (b) {
        var on = b === langBtn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyLanguage(root);
      return;
    }

    var pack = t.closest('[data-sb-pack]');
    if (pack) {
      if (s.busy) return;
      choosePack(root, pack, true);
      return;
    }

    var plus = t.closest('[data-sb-plus]');
    var minus = t.closest('[data-sb-minus]');
    if (plus || minus) {
      var card = t.closest('[data-sb-card]');
      if (!card || s.busy) return;
      var name = card.dataset.stickerName;
      var n = s.counts.get(name) || 0;
      if (plus) {
        if (s.isSingle || s.target === 0 || chosenTotal(s) >= s.target) return;
        s.counts.set(name, n + 1);
      } else {
        if (n <= 0) return;
        s.counts.set(name, n - 1);
      }
      showMessage(root, '', '');
      render(root);
      return;
    }

    if (t.closest('[data-sb-add]')) {
      event.preventDefault();
      addToCart(root);
    }
  });

  /* Na stránke nálepky riadi jazyk možnosť „Jazyk“ priamo pri produkte. */
  document.addEventListener('ao:sticker-lang', function (event) {
    var detail = (event && event.detail) || {};
    document.querySelectorAll(ROOT_SEL + '[data-sb-expanded="true"]').forEach(function (root) {
      var s = state(root);
      var next = detail.lang === 'cz' ? 'cz' : 'sk';
      var single = singlePackOf(root);
      if (single && detail.variantId) single.dataset[next === 'cz' ? 'variantCz' : 'variantSk'] = String(detail.variantId);
      if (single && detail.priceText) {
        single.dataset.priceText = detail.priceText;
        if (s.isSingle) s.priceText = detail.priceText;
      }
      if (next === s.lang) {
        if (s.isSingle) s.variantId = singleVariantId(root, s);
        render(root);
        return;
      }
      s.lang = next;
      applyLanguage(root);
    });
  });

  /* Prvé zobrazenie každého mixéra (aj tých, čo vzniknú po prekreslení). */
  function boot() {
    document.querySelectorAll(ROOT_SEL).forEach(function (root) {
      if (root.__aoSbBooted) return;
      root.__aoSbBooted = true;
      var fresh = !states.has(root);
      var s = state(root);
      if (fresh && s.expanded) {
        var single = singlePackOf(root);
        var smallest = single || packsOf(root).reduce(function (best, p) {
          var n = Number(p.dataset.count) || 0;
          var bestN = best ? Number(best.dataset.count) || 0 : Infinity;
          return n > 0 && n < bestN ? p : best;
        }, null);
        if (smallest) {
          choosePack(root, smallest, false);
          if (!s.isSingle && s.target === 1) {
            var selfCard = root.querySelector('[data-sb-card][data-sb-self="true"]');
            if (selfCard) s.counts.set(selfCard.dataset.stickerName, 1);
          }
        }
      }
      syncFromState(root);
    });
  }

  var bootQueued = false;
  function queueBoot() {
    if (bootQueued) return;
    bootQueued = true;
    window.requestAnimationFrame(function () { bootQueued = false; boot(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', queueBoot);
  document.addEventListener('cart:update', function () { window.setTimeout(queueBoot, 60); });
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes && records[i].addedNodes.length) { queueBoot(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
